import React from 'react'
import PropTypes from 'prop-types'
import './style.scss'

class NewReactVC extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      trigger: false,
    }
    this.firstFunction = this.firstFunction.bind(this)
  }

  firstFunction() {}

  render() {
    const { title, customClass, data, strings } = this.props
    const { trigger } = this.state

    console.log(data) //eslint-disable-line

    return (
      <div
        className={'dhsv_vc_new_react' + (customClass ? ' ' + customClass : '')}
      >
        <span className="title">{title}</span>
        <p className={trigger ? 'triggered' : ''}>{strings.text}</p>
      </div>
    )
  }
}

NewReactVC.propTypes = {
  title: PropTypes.string,
  customClass: PropTypes.string,
  data: PropTypes.array,
  strings: PropTypes.object,
}

export default NewReactVC
